export default "__VITE_ASSET__912bd3df__"